<template>
  <div v-if="isIdle === true && DisableConfirmation === false">
    <v-dialog v-model="isIdle" max-width="600">
      <v-card class="pt-10 px-10">
        <span class="headline">{{messageText}}</span>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="public-blue" @click="isIdle = false">{{ButtonText}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'LoadingIdle',
  props: {
    IdleTimeout: Number,
    WarningTimeout: Number,
    DialogText: { required: true },
    ButtonText: { required: true },
    DisableConfirmation: Boolean,
  },
  data() {
    return {
      idleTimer: '',
      warningTimer: '',
      countDownInterval: '',
      isIdle: Boolean,
      isTimedOut: Boolean,
      secondsRemaining: Number,
    };
  },
  computed: {
    messageText() {
      return this.DialogText.replace('##', this.secondsRemaining);
    },
  },
  created() {
    this.isIdle = false;
    this.secondsRemaining = 30;
    this.startIdleTimeOut();
    document.addEventListener('click', this.onRefresh);
    document.addEventListener('mousemove', this.onRefresh);
    // this.IdleTimeout = this.IdleTimeout || 20;
  },
  methods: {
    onRefresh() {
      if (this.idleTimer && !this.isIdle) {
        clearTimeout(this.idleTimer);
        this.startIdleTimeOut();
      }
      if (this.warningTimer) {
        clearTimeout(this.warningTimer);
        clearInterval(this.countDownInterval);
      }
    },
    setIsIdle(value) {
      this.isIdle = value;
    },
    warningTimeout() {
      this.$emit('OnWarningTimeout');
    },
    idleTimeout() {
      this.setIsIdle(true);
      this.startWarningTimeout();
    },
    startIdleTimeOut() {
      // console.log(this.IdleTimeout);
      const idletimeout = this.idleTimeout;
      this.idleTimer = setTimeout(() => {
        idletimeout();
      }, this.IdleTimeout * 60 * 1000);
    },
    startWarningTimeout() {
      const warningtimeout = this.warningTimeout;
      if (this.DisableConfirmation === false) {
        this.startWarningCountDown();
        this.warningTimer = setTimeout(() => {
          warningtimeout();
        }, 30 * 1000);
      } else {
        warningtimeout();
      }
    },
    startWarningCountDown() {
      this.secondsRemaining = 30;
      const decrementsecondsremaining = this.decrementSecondsRemaining;
      this.countDownInterval = setInterval(() => {
        decrementsecondsremaining();
      }, 1000);
    },
    decrementSecondsRemaining() {
      this.secondsRemaining -= 1;
    },
  },
};
</script>

<style scoped>
.v-btn {
  height: 50px !important;
  color: white !important;
  width: 100px;
}
</style>
